import React from 'react';
import { Link } from 'react-router-dom';
import './navbar.css'

export default function Navbar() {
  return (
    <>
        {/* Navbar starts */}
        <nav className="navbar navbar-expand-lg sticky-top">
                <div className="container-fluid">
                    <a className="navbar-brand site-logo-container" href="/">
                        <section id="navbarLogo"></section>

                        <section id="navSiteName">
                            <span> BR Ambedkar</span>
                            <span>Fund</span>
                        </section>
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="nav navbar-nav ms-auto me-5">
                          <li className="nav-item me-2">
                              <Link to="/" className="nav-link text-white active">Home</Link>
                          </li>
                          <li className="nav-item me-2">
                              <Link to="/about" className="nav-link text-white">About</Link>
                          </li>
                          <li className='nav-item me-2'>
                              <Link to="/our-services" className="nav-link text-white">Services</Link>
                          </li>
                          <li className="nav-item me-2">
                              <Link to="/contact" className="nav-link text-white">Contact Us</Link>
                          </li>
                          <li className="nav-item me-2">
                              <Link to="/login" id="login-button" className="nav-link text-white text-center">Login</Link>
                          </li>
                        </ul>
                    </div>
                </div>
            </nav>
            {/* Navbar ends */}
    </>
  )
}
